import { html } from 'lit';
import { Info } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-info')
export class PdsIconInfo extends PdsIcon {
  @state()
  icon = Info;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
